module.exports = __webpack_public_path__ + "img/product01.35636f8f.png";